module.exports = __webpack_public_path__ + "static/media/operations_use_case_3.b651a12f.svg";